import { SvgIcon } from '../Extensions/SvgIcon';
import { ClusteredMarkerLayer } from '../Layers/ClusteredMarkersLayer';
import type { ClusteredMarkerLayerOptions } from '../Layers/Layers.types';
import PumpStation from '../PopupTemplates/PumpStation';
import { PumpStationSource } from '../Sources/PumpStationSource';

export const pumpStation = function (options?: ClusteredMarkerLayerOptions): ClusteredMarkerLayer {
    const defaultOptions: ClusteredMarkerLayerOptions = {
        name: 'PumpStation',
        itemPlural: 'cykelpumpar',
        source: new PumpStationSource(),
        customIcon: new SvgIcon({
            iconId: 'bike-pump-marker',
            iconSize: [24, 36],
            iconAnchor: [12, 36],
            popupAnchor: [0, -36],
        }),
        customClusterIconId: 'bike-pump-cluster',
        popupTemplate: PumpStation,
    };

    return new ClusteredMarkerLayer({ ...defaultOptions, ...options });
};
